/**
 * Theme JS building
 */
import './modernizr';
import Theme from './theme';

// Export the theme controller for global usage.
window.Theme = Theme;

// Require main style file here for concatenation.
import '../styles/main.scss';


// This is used to watch for changes in *.hbs files in the styles directory.
// This way the styleguide automatically gets regenerated when handlebars template file is changed.
//function requireAll( r ) {
//    r.keys().forEach( r );
//}
// requireAll( require.context( '../styles/', true, /\.hbs$/ ) );



// WEBPACK FOOTER //
// ./assets/scripts/main.js